import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { Permissions } from 'src/app/models/permissions/permissions';
import { CenterBasic } from 'src/app/models/center/center-basic';
import { ModulesDto } from 'src/app/models/center/modules-dto';
import { FunctionsNames } from 'src/app/enumerates/functions-names';
import { Observable } from 'rxjs';
import { StaffLogin } from 'src/app/models/staff/staff-login';
import { RegionalConfiguration } from 'src/app/models/center/regional-configuration';
import { StaffPermissionsCategory } from 'src/app/enumerates/staff-permissions-category';
import { Guid } from 'guid-typescript';
import { HttpService } from '../http/http.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionService extends HttpService {
    // #region PermissionDefault
    private defaultPermissions: Permissions = {
        centerOptions: {
            activateMenuTrainingym: false,
            isVisibleGroupsMembersTasks: false,
            isAzureSearchActive: false,
            isAchievementsActive: false,
            isActiveOnBoarding: false,
            isActiveWorkoutGroups: false,
            isVirtualSectionActive: false,
            currency: '',
            currencyCode: '',
            creditValue: 0
        },
        staff: {
            language: {
                id: 0,
                languageName: '',
                codeLanguage: ''
            },
            staff: {
                id: 0,
                name: '',
                lastName: '',
                email: '',
                token: Guid.createEmpty(),
                urlPhoto: '',
                mobile: '',
                checked: false
            },
            isTemporalPassword: false,
            mustFillEmail: false,
            permission: '',
            country: '',
            username: ''
        },
        staffMemberPermissions: {
            tabAnalysis: false,
            tabWorkout: false,
            tabHealth: false,
            tabAccess: false,
            tabObjectives: false,
            tabTest: false,
            tabMarketing: false,
            tabRelationships: false,
            tabResults: false,
            tabHistory: false,
            tabDiet: false,
            canExportMemberList: false,
            canImportMemberList: false,
            canViewUserProfile: false,
            memberExtraPermissions: false,
            fieldExtraLayerNotifications: false,
            fieldEmail: false,
            fieldKey: false,
            fieldUser: false,
            fieldName: false,
            fieldSurname: false,
            fieldGender: false,
            fieldAddress: false,
            fieldNif: false,
            fieldCountry: false,
            fieldPostcode: false,
            fieldBirthDate: false,
            fieldLandLine: false,
            fieldMobile: false,
            fieldLanguage: false,
            fieldProfession: false,
            fieldActivityLevel: false,
            fieldHeight: false,
            fieldStyle: false,
            fieldObservations: false,
            fieldExtraLayer: false,
            fieldMarketing: false,
            fieldProfile: false,
            bMemberQuestionnaires: false
        },
        staffPermissionFull: {
            staffPermission: {
                installApps: false,
                canViewMyStaffProfile: false,
                subsectionBusinessKPI: false,
                subsectionFitness: false,
                subsectionAdministrator: false,
                seeMembersFollowup: false,
                memberFilter: false,
                sectionMembers: false,
                subsectionMembersActive: false,
                subsectionMembersPotential: false,
                subsectionMembersCanceled: false,
                subsectionMembersUnification: false,
                tabGroups: false,
                tabProfiles: false,
                canConfigureMemberList: false,
                membersExtra: false,
                sectionStaffs: false,
                subsectionStaffsList: false,
                subsectionStaffsProgramming: false,
                subsectionStaffsAssign: false,
                subsectionStaffsAssistance: false,
                subsectionProfileTasks: false,
                editTasks: false,
                sectionMarketing: false,
                subsectionEmail: false,
                subsectionSms: false,
                subsectionPush: false,
                subsectionQuizs: false,
                subsectionAdvertisingWorkout: false,
                subsectionAdvertisingKiosk: false,
                subsectionWebPage: false,
                subsectionQuestionnaires: false,
                subsectionAppAd: false,
                sectionCenter: false,
                subsectionData: false,
                subsectionMachines: false,
                subsectionRooms: false,
                subsectionConfigurationCenter: false,
                subsectionConfigurationGroupsActivities: false,
                subsectionConfigurationGroupsDifficulties: false,
                subsectionConfigurationGroupsObjetives: false,
                subsectionConfigurationBooking: false,
                subsectionPermissions: false,
                subsectionEmailAccount: false,
                subsectionEmailSignature: false,
                subsectionTGCustom: false,
                canTranslate: false,
                sectionSubscription: false,
                subsectionHealthScore: false,
                subsectionAutomaticCapacity: false,
                subsectionCapacityConfiguration: false,
                subsectionCapacityStatus: false,
                sectionActivities: false,
                subsectionEditionActivities: false,
                subsectionManagerBookings: false,
                subsectionCalendar: false,
                canValidateActivities: false,
                canValidateOnlyMyActivities: false,
                canValidateOnlyTodayActivities: false,
                sectionWorkout: false,
                subsectionExercises: false,
                isVisibleOnlyMyWorkout: false,
                canManageExercises: false,
                listWorkouts: false,
                subsectionSharedWorkout: false,
                sectionReports: false,
                sectionLoyalty: false,
                subsectionTemplates: false,
                subsectionAchievements: false,
                bLoyalty: false,
                subsectionAutomaticSurveys: false,
                sectionVirtualClasses: false,
                sectionPayments: false,
                subsectionPaymentsOperations: false,
                idCategory: StaffPermissionsCategory.management,
                category: '',
                permission: '',
                canEditAssignedWorkout: false,
                canAssignStaffPermission: false
            },
            staffReportsPermissions: {
                subsectionAccess: false,
                subsectionWorkoutStaff: false,
                subsectionAssistanceActivitiesCenter: false,
                subsectionAnalysisActivities: false,
                subsectionSummaryAssistanceActivities: false,
                subsectionReportsActivities: false,
                subsectionAssistanceActivities: false,
                subsectionAssistanceRooms: false,
                subsectionStaffTasks: false,
                subsectionMembersTasks: false,
                subsectionTasks: false,
                subsectionHistoricalDiets: false,
                subsectionMembersHealthScore: false,
                subsectionTechnologicalReachCompanyChain: false,
                subsectionActivitiesCompanyChain: false,
                subsectionMemberReport: false,
                subsectionUseSpaceCenter: false,
                subsectionQuestionnaires: false
            },
            staffMemberPermissions: {
                tabAnalysis: false,
                tabWorkout: false,
                tabHealth: false,
                tabAccess: false,
                tabObjectives: false,
                tabTest: false,
                tabMarketing: false,
                tabRelationships: false,
                tabResults: false,
                tabHistory: false,
                tabDiet: false,
                canExportMemberList: false,
                canImportMemberList: false,
                canViewUserProfile: false,
                memberExtraPermissions: false,
                fieldExtraLayerNotifications: false,
                fieldEmail: false,
                fieldKey: false,
                fieldUser: false,
                fieldName: false,
                fieldSurname: false,
                fieldGender: false,
                fieldAddress: false,
                fieldNif: false,
                fieldCountry: false,
                fieldPostcode: false,
                fieldBirthDate: false,
                fieldLandLine: false,
                fieldMobile: false,
                fieldLanguage: false,
                fieldProfession: false,
                fieldActivityLevel: false,
                fieldHeight: false,
                fieldStyle: false,
                fieldObservations: false,
                fieldExtraLayer: false,
                fieldMarketing: false,
                fieldProfile: false,
                bMemberQuestionnaires: false
            },
            staffNotificationsPermissions: {
                sendNotificationsFromMemberList: false
            },
            staffCenterPermission: {
                isActiveChat: false
            }
        },
        staffCenterPermission: {
            isActiveChat: false
        },
        chatCenter: {
            isActive: false
        }
    };
    // #endregion

    constructor(private readonly router: Router, private readonly cookieService: CookieService, private readonly userService: UserService) {
        super();
    }

    removePermissions(): void {
        localStorage.removeItem('permissions');
    }

    setPermissions(permissions: Permissions): void {
        localStorage.setItem('permissions', JSON.stringify(permissions));
    }

    getPermissions(): Permissions {
        const permissionsString = localStorage.getItem('permissions');
        let permissions: Permissions = this.defaultPermissions;
        if (permissionsString) {
            permissions = JSON.parse(permissionsString ?? '');
        }

        return permissions;
    }

    updatePermissions(permissions: Permissions): void {
        this.setPermissions(permissions);
    }

    canEditActivitiesCalendar(): boolean {
        const permissions = this.getPermissions();
        if (permissions) {
            return permissions.staffPermissionFull.staffPermission.subsectionCalendar;
        }

        return false;
    }

    hasTabWorkoutPermission(): boolean {
        const permissions = this.getPermissions();
        if (permissions) {
            return permissions.staffMemberPermissions.tabWorkout;
        }

        return false;
    }


    canValidateSchedule(): boolean {
        const permissions = this.getPermissions();
        if (permissions) {
            return permissions.staffPermissionFull.staffPermission.canValidateActivities;
        }

        return false;
    }

    memberControlPermission(): boolean {
        const center = this.userService.getCenter();
        if (center) {
            return  center.permissions.memberControl;
        }

        return false;
    }

    canValidateOnlyAssignedActivities(): boolean {
        const permissions = this.getPermissions();
        if (permissions) {
            return permissions.staffPermissionFull.staffPermission.canValidateOnlyMyActivities;
        }

        return false;
    }

    canValidateOnlyMyActivities(): boolean {
        // TODO: Revisar si este permiso y el de "canValidateOnlyAssignedActivities" son correctos.
        return this.canValidateOnlyAssignedActivities();
    }

    canValidateOnlyTodayActivities(): boolean {
        const permissions = this.getPermissions();
        if (permissions) {
            return permissions.staffPermissionFull.staffPermission.canValidateOnlyTodayActivities;
        }

        return false;
    }

    getCenter(): CenterBasic | null {
        const center = localStorage.getItem('center');
        if (center) {
            return JSON.parse(center);
        }

        return null;
    }

    getCenterModule(): ModulesDto | undefined {
        if (this.cookieService.get('centerModule')) {
            return JSON.parse(this.cookieService.get('centerModule'));
        }

        return undefined;
    }

    getFullCenterInfo(): RegionalConfiguration | null {
        const fullCenterInfo = localStorage.getItem('center');

        if (fullCenterInfo) {
            return JSON.parse(fullCenterInfo).regionalConfiguration;
        }

        return null;
    }

    getInternalizationData(): any {
        const internationalizationData = localStorage.getItem('internationalization');
        if (internationalizationData) {
            return JSON.parse(internationalizationData);
        }

        return null;
    }

    checkPermissions(data: any): boolean {
        if (!data.permission || this.checkPermissionsFunction(data.permission)) {
            return true;
        }

        if (data.redirect) {
            void this.router.navigateByUrl(data.redirect);
        } else {
            void this.router.navigateByUrl('unauthorized');
        }

        return false;
    }

    checkPermissionsFunction(functionName: FunctionsNames): boolean {
        return this[functionName]();
    }

    hasWorkoutGroupPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.sectionWorkout;
    }

    hasListWorkoutsPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.listWorkouts;
    }

    canEditAssignedWorkoutsPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.canEditAssignedWorkout;
    }

    canAssignWorkoutsPermission(): boolean {
        return this.hasListWorkoutsPermission() || this.canEditAssignedWorkoutsPermission();
    }

    hasStaffChatActive(): boolean {
        return this.getPermissions().staffPermissionFull.staffCenterPermission.isActiveChat;
    }

    isActiveSubsectionFitness(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionFitness;
    }

    isAssistanceActive(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.canValidateActivities;
    }
    isCanManageCenterMember(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.canAssignStaffPermission;
    }

    isControlCapacityActive(): boolean {
        const data = this.getCenterModule();
        if (data)  {
            return data.isControlCapacityActivated;
        }

        return false;
    }

    getCurrency(): string {
        return this.getPermissions().centerOptions.currency;
    }

    getCreditValue(): number {
        return this.getPermissions().centerOptions.creditValue;
    }

    updatePassword(idStaff: number, password: string): Observable<void> {
        const url = `staff/${idStaff}/password`;

        return this.put(url, { app: 'center', version: 1 }, { password, idUser: idStaff });
    }

    updateUsername(username: string): Observable<void> {
        const url = 'nicknames';

        return this.put(url, { app: 'center', version: 1}, { value: username });
    }

    isUsernameAvailableModified(username: string): Observable<boolean> {
        const url = `nicknames/modified?available=${username}`;

        return this.get(url, { app: 'center', version: 1 });
    }

    getStaffData(): StaffLogin | null {
        if (this.cookieService.get('staffData')) {
            return JSON.parse(this.cookieService.get('staffData'));
        }

        return null;
    }

    hasSubsectionActiveMembersPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionMembersActive;
    }

    hasSubsectionBusinessKpi(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionBusinessKPI;
    }

    hasSubsectionPotentialMembersPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionMembersPotential;
    }

    hasSubsectionDroppedMembersPermission(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionMembersCanceled;
    }

    hasSubsectionCalendar(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionCalendar
            || this.getPermissions().staffPermissionFull.staffPermission.canValidateActivities
            || this.getPermissions().staffPermissionFull.staffPermission.canValidateOnlyMyActivities
            || this.getPermissions().staffPermissionFull.staffPermission.canValidateOnlyTodayActivities;
    }

    hasActiveMember(): boolean {
        return this.getPermissions().staffPermissionFull.staffPermission.subsectionMembersActive;
    }

    hasViewUserProfile(): boolean {
        const userProfile = this.getPermissions().staffPermissionFull.staffMemberPermissions;

        return userProfile.tabAnalysis || userProfile.tabWorkout
                || userProfile.tabHealth || userProfile.tabObjectives
                || userProfile.tabTest || userProfile.tabMarketing
                || userProfile.tabRelationships || userProfile.tabResults
                || userProfile.tabResults || userProfile.tabHistory
                || userProfile.tabDiet || userProfile.tabAccess;
    }

    getMemberPermission(): any {
        const staffPermissionFull = this.getPermissions().staffPermissionFull;

        return {
            fieldEmail: staffPermissionFull.staffMemberPermissions.fieldEmail,
            fieldKey: staffPermissionFull.staffMemberPermissions.fieldKey,
            fieldUser: staffPermissionFull.staffMemberPermissions.fieldUser,
            fieldName: staffPermissionFull.staffMemberPermissions.fieldName,
            fieldSurname: staffPermissionFull.staffMemberPermissions.fieldSurname,
            fieldGender: staffPermissionFull.staffMemberPermissions.fieldGender,
            fieldAddress: staffPermissionFull.staffMemberPermissions.fieldAddress,
            fieldNif: staffPermissionFull.staffMemberPermissions.fieldNif,
            fieldCountry: staffPermissionFull.staffMemberPermissions.fieldCountry,
            fieldPostcode: staffPermissionFull.staffMemberPermissions.fieldPostcode,
            fieldBirthDate: staffPermissionFull.staffMemberPermissions.fieldBirthDate,
            fieldLandLine: staffPermissionFull.staffMemberPermissions.fieldLandLine,
            fieldMobile: staffPermissionFull.staffMemberPermissions.fieldMobile,
            fieldLanguage: staffPermissionFull.staffMemberPermissions.fieldLanguage,
            fieldProfession: staffPermissionFull.staffMemberPermissions.fieldProfession,
            fieldActivityLevel: staffPermissionFull.staffMemberPermissions.fieldActivityLevel,
            fieldHeight: staffPermissionFull.staffMemberPermissions.fieldHeight,
            fieldStyle: staffPermissionFull.staffMemberPermissions.fieldStyle,
            fieldObservations: staffPermissionFull.staffMemberPermissions.fieldObservations,
            fieldExtraLayer: staffPermissionFull.staffMemberPermissions.fieldExtraLayer,
            fieldMarketing: staffPermissionFull.staffMemberPermissions.fieldMarketing,
            fieldProfile: staffPermissionFull.staffMemberPermissions.fieldProfile,
            tabAnalysis: staffPermissionFull.staffMemberPermissions.tabAnalysis,
            tabWorkout: staffPermissionFull.staffMemberPermissions.tabWorkout,
            tabHealth: staffPermissionFull.staffMemberPermissions.tabHealth,
            tabAccess: staffPermissionFull.staffMemberPermissions.tabAccess,
            tabObjectives: staffPermissionFull.staffMemberPermissions.tabObjectives,
            tabTest: staffPermissionFull.staffMemberPermissions.tabTest,
            tabMarketing: staffPermissionFull.staffMemberPermissions.tabMarketing,
            tabRelationships: staffPermissionFull.staffMemberPermissions.tabRelationships,
            tabResults: staffPermissionFull.staffMemberPermissions.tabResults,
            tabHistory: staffPermissionFull.staffMemberPermissions.tabHistory,
            tabDiet: staffPermissionFull.staffMemberPermissions.tabDiet,
            membersExtra: staffPermissionFull.staffPermission.membersExtra,
            bMemberQuestionnaires : staffPermissionFull.staffMemberPermissions.bMemberQuestionnaires
        };
    }
}
